<template>
    <div>
        <div class="card-body">
            <b-tabs 
                active-nav-item-class="text-info"
            >
                <b-tab v-for="tab in tabTitle" :key="tab.key" @click="table.tabKey = tab.key">
                    <template v-slot:title>
                        <div class="mx-3">{{tab.name}}</div> 
                    </template>
                    <div id="tablePrint">
                        <TableParcel 
                            ref="shipmentTable" 
                            :table="table" 
                            :reportParcel="reportParcel" 
                            @getReportShipmentPending="getReportShipmentPending" 
                        />
                    </div>
                </b-tab>
                <template #tabs-end>
                    <li class="position-btn-right">
                        <template v-if="['PENDING'].includes(table.tabKey)">
                            <b-button 
                                size="sm" 
                                variant="default" 
                                class="px-4"
                                :disabled="table.isLoadingBtn || table.selectedParcel < 1"
                                @click="selectedUpdateVisible()"
                            >
                                <i class="fas fa-circle-notch fa-spin" v-if="table.isLoadingBtn"></i> แจ้งลูกค้า
                            </b-button>
                        </template>
                        <template v-if="table.tabKey === 'WAITING_FEEDBACK'">
                            <template v-if="table.btnEdit">
                                <b-button 
                                    size="sm" 
                                    variant="success" 
                                    class="px-4" 
                                    :disabled="table.isLoadingBtn"
                                    @click="selectedUpdateFeedback()"
                                >
                                    <i class="fas fa-circle-notch fa-spin" v-if="table.isLoadingBtn"></i> บันทึก
                                </b-button>
                                <b-button 
                                    size="sm" 
                                    variant="danger" 
                                    class="px-4" 
                                    :disabled="table.isLoadingBtn"
                                    @click="swichBtnEdit()"
                                >
                                    ยกเลิก
                                </b-button>
                            </template>
                            <template v-else>
                                <b-button size="sm" variant="primary" class="px-4" @click="swichBtnEdit()">
                                    แก้ไข
                                </b-button>
                            </template>
                        </template>
                    </li>
                </template>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import TableParcel from '@/components/custom/reportParcel/TableParcel'
import { getShipmentPending } from "@/axios/failReport.js";

export default {
    props:{
        search: Object,
        reportParcel: Object
    },
    components:{
        TableParcel
    },
    data(){
        return{
            table:{
                tabKey:'WAITING_FEEDBACK',
                btnEdit: false,
                isLoadingBtn:false,
                isLoading: false,
                selectedParcel: [],
                checkSelect: false,
            }
        }
    },
    methods:{
        async getReportShipmentPending(){
            this.table.isLoading = true;
            await getShipmentPending( this.search ).then( res => {
                this.reportParcel.items = res;
                this.table.isLoadingBtn = false
                this.table.isLoading = false;
            }).catch(error => {
                this.table.isLoadingBtn = false
                this.table.isLoading = false;
            });
        },
        selectedUpdateVisible(){
            this.table.isLoadingBtn = true
            let index = this.getIndexRefsTable;
            this.$refs.shipmentTable[index].updateVisible(
                this.table.selectedParcel
            )
        },
        selectedUpdateFeedback(){
            this.$refs.shipmentTable[this.getIndexRefsTable].updateFeedback();
        },
        // selectedUpdateStatusCourier(){
        //     this.table.isLoadingBtn = true
        //     let index = this.getIndexRefsTable;
        //     this.$refs.shipmentTable[index].updateStatusCourier(
        //         this.$refs.shipmentTable[index].selectedParcel
        //     );
        // },
        swichBtnEdit(){
            this.table.btnEdit = !this.table.btnEdit
        },
       
    },
    computed: {
        tabTitle(){
            return  [
                // { key:'PENDING', name:'รอแจ้งลูกค้า' },
                { key:'WAITING_FEEDBACK', name:'รอลูกค้าตอบกลับ' },
                { key:'REPLIED', name:'ที่ลูกค้าตอบกลับ' },
                { key:'RESOLVED', name:'จัดการแล้ว' },
            ]
        },
        getIndexRefsTable(){
            let index = this.tabTitle.findIndex(tab => {
                return tab.key == this.table.tabKey
            });
            return index
        }
    }
}
</script>